import React from 'react';

import Scrollable from '../../shared/tools/Scrollable';

import styles from './Section.module.scss';


class Section extends React.Component {
  static defaultProps = {
    bgImage: undefined,
    title: undefined,
    id: undefined,
  }

  constructor(props) {
    super(props);

    this.refers = {
      section: React.createRef(),
    }
  }

  componentDidMount() {
    if (this.props.id) {
      Scrollable.register(this.props.id, this.refers.section);
    }
  }

  onClickTitle = () => {
    Scrollable.scrollTo(this.props.id);
  }

  render() {
    return (
      <div className={styles.Section} ref={this.refers.section}>
        <div className={styles.TitleContainer}>
          <img alt='' src={this.props.bgImage}/>
          <div className={styles.Filter}/>
          <div className={styles.Title} onClick={this.onClickTitle}>{this.props.title}</div>
        </div>
        <div className={styles.Content}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default Section;
